import logoChespa from '../assets/images/loga/chespa-logo.png';
import logoKsi from '../assets/images/loga/ksi-logo.png';
import logoTCF from '../assets/images/loga/tcf-logo.png';
import logoOSP from '../assets/images/loga/osp-logo.png';

const PARTNERS = [
    { href: 'https://www.chespa.eu', logo: logoChespa, label: 'Chespa Sp. z o.o.' },
    {
        href: 'https://www.ksinternet.pl',
        logo: logoKsi,
        label: 'Krapkowickie sieci internetowe',
    },
    { href: 'https://osp.zywocice.pl', logo: logoOSP, label: 'OSP Żywocice' },
    {
        href: 'https://thecodefoxes.com',
        logo: logoTCF,
        label: 'TheCodeFoxes - Krzysztof Joszko',
    },
];

export default function Footer() {
    return (
        <footer className="border-t border-gray-200/80 bg-[#F8F9FA]">
            <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 2xl:px-0">
                <h2 className="text-center text-sm sm:text-base font-medium text-gray-500 pt-10 sm:pt-12">
                    Transmisja możliwa dzięki:
                </h2>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-x-5 gap-y-9 sm:gap-x-8 sm:gap-y-10 py-8 sm:py-10 md:py-12 items-start">
                    {PARTNERS.map(({ href, logo, label }) => (
                        <a
                            key={href}
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group flex flex-col items-center gap-2.5 sm:gap-3 text-center rounded-lg px-2 py-1 -mx-2 -my-1 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-main-green/40 focus-visible:ring-offset-2 focus-visible:ring-offset-[#F8F9FA]"
                        >
                            <span className="flex h-12 sm:h-14 w-full max-w-[10.5rem] mx-auto items-center justify-center">
                                <img
                                    src={logo}
                                    alt=""
                                    className="max-h-10 sm:max-h-12 w-auto max-w-full object-contain object-center opacity-90 transition-opacity group-hover:opacity-100"
                                    decoding="async"
                                />
                            </span>
                            <span className="text-[11px] sm:text-sm text-gray-500 leading-snug group-hover:text-gray-700">
                                {label}
                            </span>
                        </a>
                    ))}
                </div>
                <hr className="border-gray-200/90" />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 py-8 md:py-9 items-center justify-items-center md:justify-items-stretch text-center md:text-left">
                    <p className="text-sm text-gray-500 md:justify-self-start order-2 md:order-1">
                        © 2026{' '}
                        <a
                            href="https://zywocice.pl/"
                            className="text-gray-600 hover:text-gray-900 hover:underline underline-offset-2"
                        >
                            zywocice.pl
                        </a>
                    </p>
                    <div className="flex flex-wrap items-center justify-center md:justify-end gap-x-2 gap-y-1.5 text-sm text-gray-600 order-1 md:order-2 w-full md:w-auto">
                        <span className="text-gray-500">Realizacja i wsparcie:</span>
                        <a
                            href="https://thecodefoxes.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-main-green/45 focus-visible:ring-offset-2 focus-visible:ring-offset-[#F8F9FA]"
                        >
                            <img
                                src={logoTCF}
                                alt="TheCodeFoxes"
                                className="h-7 sm:h-8 w-auto max-w-[7.5rem] object-contain object-center opacity-90 hover:opacity-100 transition-opacity"
                                decoding="async"
                            />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
